import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  IconButton,
  Typography,
  Button,
  TextField,
  Autocomplete,
  Grid,
  Divider,
  Checkbox,
} from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CloseIcon from "@mui/icons-material/Close";
import BackspaceIcon from "@mui/icons-material/Backspace";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import EditPermissionsTable from "../../PermissionsTable/edituserpermission/EditPermissionsTable";
import {
  getRequest,
  putRequest,
} from "../../../../services/api/axios_api_Request";
import "./EditUserModal.scss";
import { toast } from "react-toastify";

const EditUserModal = ({ editUserOpen, handleEditUserClose, clickedUser }) => {
  const [permissions, setPermissions] = useState([
    {
      application: "",
      access_level: "",
      read: false,
      write: false,
      delete: false,
    },
  ]);
  console.log("perm in edit user", permissions);
  const [appData, setAppData] = useState([]);
  const [sowIds, setSowIds] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userIds, setUserIds] = useState([]);
  const [profileImageSrc, setProfileImageSrc] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [editedUser, setEditedUser] = useState({
    userId: "",
    username: "",
    app_roles: [],
    clients: "",
    dept_id: 0,
    isSuperAdmin: 0,
    status: "",
    email: "",
    img_name: null,
    img_url: null,
    sowId: [],
    sows: "",
  });

  const [fetchedAccessLevels, setFetchedAccessLevels] = useState([]);
  const superAdminOptions = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];
  console.log("current user data in edit modal", clickedUser);
  console.log("edited user data in edit modal", editedUser);

  // Add a new permission row
  const handleAddPermission = () => {
    if (permissions.length > 0) {
      const lastPermission = permissions[permissions.length - 1];
      if (!lastPermission.application || !lastPermission.access_level) {
        return; // Do not add a new row if the last one is empty
      }
    }
    setPermissions([
      ...permissions,
      {
        application: "",
        access_level: "",
        read: false,
        write: false,
        delete: false,
      },
    ]);
  };

  // Fetch data when modal is open
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // await fetchAccessLevels();
        await fetchEditUserData();
        await fetchApplications();
        await fetchClientData();
        await fetchDepartments();
        await fetchSowIds();
        await fetchUserIds();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (editUserOpen) {
      fetchData();
    }
  }, [editUserOpen]);

  useEffect(() => {
    if (editUserOpen && permissions.length > 0) {
      // Check if any app is 1, 2 or 3
      const shouldShowAdditionalFields = permissions.some(
        (perm) =>
          perm.application && [1, 2, 3].includes(parseInt(perm.application))
      );

      setShowAdditionalFields(shouldShowAdditionalFields);

      if (!shouldShowAdditionalFields) {
        setEditedUser((prev) => ({
          ...prev,
          clients: "",
          deptId: "",
          sowId: [],
          sows: "",
        }));
      }
    }
  }, [permissions, editUserOpen]);

  const fetchClientData = async () => {
    try {
      const res = await getRequest("admin/unique-clients");
      if (res?.status === 200) {
        const clientsData = res?.data?.clients || [];
        // Map the response to format the client names and ids for the UI
        const formattedClients = clientsData.map((client) => ({
          label: client.client_name, // this will be displayed in the UI
          id: client.client_id, // this will be sent to the backend
        }));
        setClientData(formattedClients);
      } else {
        console.error("Failed to fetch client data:", res);
      }
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };
  const fetchDepartments = async () => {
    console.log("inside fetchDepartments edit");

    try {
      const res = await getRequest("admin/unique-departments");
      if (res?.status === 200) {
        const departmentsData = res?.data?.dept_list || [];
        setDepartments(departmentsData);
      } else {
        console.error("Failed to fetch departments:", res);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
  const fetchSowIds = async () => {
    try {
      const res = await getRequest("admin/sowid-title-list");
      if (res?.status === 200) {
        const sowIdsData = res?.data?.sows || [];
        const sowids = sowIdsData.map((sows) => ({
          label: sows.member_name,
          id: sows.sow_id, // 'id' will hold the sow_id
          // title: sows.title || "Title Not Available",  // Assuming the title is present in the response
        }));
        setSowIds(sowids);
      } else {
        console.error("Failed to fetch SoW IDs:", res);
      }
    } catch (error) {
      console.error("Error fetching SoW IDs:", error);
    }
  };
  const fetchUserIds = async () => {
    try {
      const res = await getRequest("admin/userid-details");
      if (res?.status === 200) {
        const userIdsData = res?.data?.emp_list || [];
        const formattedUserIds = userIdsData.map((item) => ({
          id: item.user_id,
        }));
        setUserIds(formattedUserIds);
      } else {
        console.error("Failed to fetch user IDs:", res);
      }
    } catch (error) {
      console.error("Error fetching user IDs:", error);
    }
  };
  const fetchApplications = async () => {
    try {
      const res = await getRequest("/admin/unique-applications");
      if (res?.status === 200) {
        const applications = res?.data?.applications || [];
        console.log("Fetched applications from API:", applications);

        const appNamesWithIds = applications?.map((app) => ({
          app_id: app.app_id || "Unknown ID",
          app_name: app.app_name || "Unknown App",
        }));

        setAppData(appNamesWithIds);
      }
    } catch (error) {
      console.error("Error fetching applications:", error);
    }
  };
  // const fetchAccessLevels = async () => {
  //   try {
  //     const res = await getRequest("admin/unique-access-levels");
  //     if (res?.status === 200) {
  //       const accessLevelData = res?.data?.access_levels || [];
  //       setFetchedAccessLevels(accessLevelData); // Set fetched fetchedAccessLevels
  //     } else {
  //       console.error("Failed to fetch access levels:", res);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching access levels:", error);
  //   }
  // };
  const fetchEditUserData = async () => {
    try {
      const res = await getRequest("admin/get-user-info", {
        user_id: clickedUser?.id,
      });
      if (res?.status === 200) {
        const userData = res?.data?.user_info || [];
        console.log("dddddd etch edit user dataaaa", userData);
        const formattedData = {
          userId: userData?.user_id || "", // Default to empty string if undefined
          username: userData?.username || "",
          app_roles: userData?.app_roles || [], // Default to empty array if undefined
          clients: userData?.client_id || "",
          deptId: userData?.dept_id !== undefined ? userData.dept_id : null, // Default to null if undefined
          isSuperAdmin:
            userData?.is_superadmin !== undefined ? userData.is_superadmin : 0, // Default to 0 if undefined
          status: userData?.status !== undefined ? userData.status : null, // Default to null if undefined
          email: userData?.email || "",
          img_name: userData?.img_name || null,
          img_url: userData?.img_url || null,
          sowId: userData?.sow_ids || [], // Default to empty array if undefined
          sows: userData?.sows || null,
        };
        setEditedUser(formattedData);
        setPermissions(userData?.app_roles);
        if (userData.img_url) {
          try {
            const base64Image = `data:image/png;base64,${userData.img_url}`;
            setProfileImageSrc(base64Image);
          } catch (error) {
            console.error("Error creating base64 image:", error);
          }
        } else {
          setProfileImageSrc(null); // Clear the profile image if img_url is null
        }
        console.log("fffffff permissions", userData?.app_roles);
        console.log("fffffff etch edit user dataaaa", formattedData);
      } else {
        console.error("Failed to fetch edit user details:", res);
      }
    } catch (error) {
      console.error("Error fetching edit user details:", error);
    }
  };

  // Handle permission changes for permissions
  const handlePermissionChange = (index, typeOrPermissions, value) => {
    if (typeOrPermissions === "application") {
      // Update permissions first
      const updatedPermissions = [...permissions];

      if (!updatedPermissions[index]) {
        updatedPermissions[index] = {
          application: "",
          access_level: "",
          read: false,
          write: false,
          delete: false,
        };
      }

      if (typeof typeOrPermissions === "object") {
        updatedPermissions[index] = {
          ...updatedPermissions[index],
          ...typeOrPermissions,
        };
      } else {
        updatedPermissions[index] = {
          ...updatedPermissions[index],
          [typeOrPermissions]: value,
        };
      }

      // Set permissions with the new value.
      setPermissions(updatedPermissions);

      // Check if any app is 1, 2 or 3
      const shouldShowAdditionalFields = updatedPermissions.some(
        (perm) =>
          perm.application && [1, 2, 3].includes(parseInt(perm.application))
      );

      setShowAdditionalFields(shouldShowAdditionalFields);

      // Clear fields if no app is 1,2 or 3.
      if (!shouldShowAdditionalFields) {
        setEditedUser((prev) => ({
          ...prev,
          clients: "",
          deptId: "",
          sowId: [],
          sows: "",
        }));
      }

      console.log("Updated Permissions by Pravin", updatedPermissions);
      console.log("Permission index being updated by mote:", index);
    } else {
      const updatedPermissions = [...permissions];

      if (!updatedPermissions[index]) {
        updatedPermissions[index] = {
          application: "",
          access_level: "",
          read: false,
          write: false,
          delete: false,
        };
      }

      if (typeof typeOrPermissions === "object") {
        updatedPermissions[index] = {
          ...updatedPermissions[index],
          ...typeOrPermissions,
        };
      } else {
        updatedPermissions[index] = {
          ...updatedPermissions[index],
          [typeOrPermissions]: value,
        };
      }

      setPermissions(updatedPermissions);

      console.log("Updated Permissions by Pravin", updatedPermissions);
      console.log("Permission index being updated by mote:", index);
    }
  };

  // Delete a permission row
  const handleDeletePermission = (index) => {
    const updatedPermissions = permissions.filter((_, i) => i !== index);
    setPermissions(updatedPermissions);

    // Duplicate logic from handlePermissionChange
    const shouldShowAdditionalFields = updatedPermissions.some(
      (perm) =>
        perm.application && [1, 2, 3].includes(parseInt(perm.application))
    );

    setShowAdditionalFields(shouldShowAdditionalFields);

    if (!shouldShowAdditionalFields) {
      setEditedUser((prev) => ({
        ...prev,
        clients: "",
        deptId: "",
        sowId: [],
        sows: "",
      }));
    }
  };

  // Clear the form fields
  const handleClear = () => {
    setEditedUser({
      userId: "",
      username: "",
      email: "",
      status: "",
      isSuperAdmin: 0,
      clients: "",
      deptId: null,
      sowId: [],
      sows: "",
      allowed_app_ids: [],
    });
    setPermissions([
      {
        application: "",
        access_level: "",
        read: false,
        write: false,
        delete: false,
      },
    ]);
    setShowAdditionalFields(false);
    setImagePreview(null);
  };

  const handleClearClose = async () => {
    handleClear();
    handleEditUserClose();
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      setEditedUser((prevUser) => ({ ...prevUser, image: reader.result }));
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleEditUser = async () => {
    try {
      const formData = new FormData();

      // Add the necessary user data to the formData object
      formData.append("user_id", editedUser?.userId);
      formData.append("username", editedUser?.username || "");
      formData.append("email", editedUser?.email || "");
      formData.append("dept_id", editedUser?.deptId || ""); // dept ID from selected depit
      formData.append("client_ids", editedUser?.clients || ""); // Clients as a comma-separated string
      formData.append("is_superadmin", editedUser?.isSuperAdmin); // Clients as a comma-separated string
      const allowedAppIds = permissions
        .map((permission) => permission?.application)
        .filter((app) => app !== "");
      formData.append("selected_app_ids", allowedAppIds.join(",")); // Send selected app IDs

      // Check if there's a file selected for upload (image)
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput?.files?.length > 0) {
        formData.append("image", fileInput.files[0]);
      }

      const appRoles = permissions
        .map((permission) => {
          if (permission?.application && permission.access_level) {
            return `${permission?.application}:${permission.access_level}`;
          }
          return null;
        })
        .filter((appRole) => appRole !== null); // Filter out null values

      formData.append("app_roles", appRoles.join(",")); // App-access level mapping

      // SoW (Statement of Work) IDs
      formData.append(
        "sows",
        editedUser?.sowId?.map((sow) => sow.id).join(",") || ""
      );

      // Send the PUT request to the backend to update the user
      const res = await putRequest("/admin/edit-user", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // Handle the response
      if (res?.status === 200) {
        const updatedUser = res?.data?.user;
        console.log("User updated successfully:", updatedUser);

        toast.success("User updated successfully");
        handleEditUserClose();
        window.location.reload();
      } else {
        toast.error(
          `Failed to update user: ${res?.data?.error || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Failed to update user");
    }
  };

  return (
    <Modal
      open={editUserOpen}
      onClose={handleClearClose}
      BackdropProps={{
        timeout: 100,
        style: {
          backdropFilter: "blur(5px)", // Adjust the blur radius as needed
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Add a semi-transparent background
        },
      }}
    >
      <Box className="edit-user-modal" sx={{ bgcolor: "background.paper" }}>
        <Box className="header">
          <Typography variant="h6">Edit User</Typography>
          <IconButton onClick={handleClearClose} className="close-button">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider className="divider" />

        <Grid container spacing={2} className="form-grid">
          <Grid item xs={9}>
            <Grid container spacing={1}>
              {/* User ID */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="User ID"
                  name="user_id"
                  value={clickedUser?.id}
                  size="small"
                  className="input-field"
                  disabled
                />
              </Grid>
              {/* User Name */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="User Name"
                  name="username"
                  value={clickedUser?.username || ""}
                  size="small"
                  className="input-field"
                  disabled
                />
              </Grid>
              {/* E-mail ID */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="E-mail ID"
                  name="email"
                  value={clickedUser?.email || ""}
                  size="small"
                  className="input-field"
                  disabled
                />
              </Grid>
              {/* Select issuperadmin */}
              <Grid item xs={6}>
                <Autocomplete
                  options={superAdminOptions}
                  fullWidth
                  getOptionLabel={(option) => option.label}
                  value={superAdminOptions.find(
                    (opt) => opt.value === (editedUser.isSuperAdmin ?? 0)
                  )} // De
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  } // Fix compari
                  onChange={(event, newValue) => {
                    setEditedUser((prevUser) => ({
                      ...prevUser,
                      isSuperAdmin: newValue?.value ?? 0, // Store value as 1 or 0, default to 0
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Make it a Super Admin?"
                      variant="outlined"
                      size="small"
                      className="input-field"
                    />
                  )}
                />
              </Grid>
              {showAdditionalFields && (
                <>
                  {/* Client Names */}
                  <Grid item xs={6}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      disableCloseOnSelect
                      options={[
                        { id: "ALL", label: "Select All" },
                        ...clientData,
                      ]} // Add "Select All" option
                      value={(editedUser.clients || "")
                        .split(",")
                        .map((id) =>
                          clientData.find((c) => c.id.toString() === id)
                        )
                        .filter((c) => c !== undefined)}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(event, value) => {
                        const isAllSelected = value.find(
                          (opt) => opt.id === "ALL"
                        );
                        const allSelected =
                          editedUser?.clients?.split(",")?.length ===
                          clientData.length;

                        if (isAllSelected) {
                          const newClientIds = allSelected
                            ? ""
                            : clientData.map((c) => c.id).join(",");

                          setEditedUser((prevUser) => ({
                            ...prevUser,
                            clients: newClientIds,
                          }));
                        } else {
                          const selectedClientIds = value
                            .map((val) => val.id)
                            .filter((id) => id !== "ALL")
                            .join(",");

                          setEditedUser((prevUser) => ({
                            ...prevUser,
                            clients: selectedClientIds,
                          }));
                        }
                      }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...rest } = props;
                        const isAll = option.id === "ALL";
                        const allSelected =
                          editedUser?.clients?.split(",")?.length ===
                          clientData.length;

                        return (
                          <li key={key} {...rest}>
                            <Checkbox
                              checked={isAll ? allSelected : selected}
                              style={{ marginRight: 8 }}
                            />
                            {option.label}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Clients"
                          size="small"
                          className="input-autocomplete"
                          InputProps={{
                            ...params.InputProps,
                            style: { height: "40px" },
                          }}
                        />
                      )}
                      required
                      sx={{
                        ".MuiAutocomplete-inputRoot": {
                          height: "40px",
                          overflow: "hidden",
                        },
                      }}
                    />
                  </Grid>

                  {/* Select Department - Edit User with Select All */}
                  <Grid item xs={6}>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      limitTags={1}
                      options={[
                        { dept_id: "ALL", dept_name: "Select All" },
                        ...departments,
                      ]}
                      fullWidth
                      value={
                        departments.length > 0 && editedUser?.deptId
                          ? departments.filter((d) =>
                              editedUser.deptId
                                .toString()
                                .split(",")
                                .includes(d.dept_id.toString())
                            )
                          : []
                      }
                      getOptionLabel={(option) => option.dept_name}
                      isOptionEqualToValue={(option, value) =>
                        option.dept_id === value.dept_id
                      }
                      onChange={(event, newValue, reason) => {
                        if (newValue.find((opt) => opt.dept_id === "ALL")) {
                          const allSelected =
                            editedUser?.deptId?.split(",")?.length ===
                            departments.length;

                          const newDeptIds = allSelected
                            ? "" // deselect all
                            : departments.map((d) => d.dept_id).join(",");

                          setEditedUser((prevUser) => ({
                            ...prevUser,
                            deptId: newDeptIds,
                          }));
                        } else {
                          const selectedDeptIds = newValue
                            .map((val) => val.dept_id)
                            .filter((id) => id !== "ALL")
                            .join(",");

                          setEditedUser((prevUser) => ({
                            ...prevUser,
                            deptId: selectedDeptIds,
                          }));
                        }
                      }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...rest } = props;
                        const isAll = option.dept_id === "ALL";
                        const allSelected =
                          editedUser?.deptId?.split(",")?.length ===
                          departments.length;

                        return (
                          <li key={key} {...rest}>
                            <Checkbox
                              checked={isAll ? allSelected : selected}
                              style={{ marginRight: 8 }}
                            />
                            {option.dept_name}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Department"
                          variant="outlined"
                          size="small"
                          className="input-field"
                          InputProps={{
                            ...params.InputProps,
                            style: { height: "40px" },
                          }}
                        />
                      )}
                      sx={{
                        ".MuiAutocomplete-inputRoot": {
                          height: "40px",
                          overflow: "hidden",
                        },
                      }}
                      required
                    />
                  </Grid>

                  {/* SoW ID */}
                  <Grid item xs={12}>
                    <Autocomplete
                      multiple
                      limitTags={1}
                      disableCloseOnSelect
                      options={sowIds}
                      value={editedUser.sowId || []}
                      getOptionLabel={(option) => `${option.label} `}
                      isOptionEqualToValue={(option, value) =>
                        !!value && option.id === value.id
                      } // Com
                      renderOption={(props, option, { selected }) => {
                        const { key, ...rest } = props;
                        return (
                          <li key={key} {...rest}>
                            <Checkbox
                              checked={selected}
                              style={{ marginRight: 8 }}
                            />
                            {option.label}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="SoW ID"
                          variant="outlined"
                          size="small"
                          className="input-select"
                        />
                      )}
                      onChange={(e, value) => {
                        const sowidsString = value
                          .map((val) => val.id)
                          .join(","); // Creates comma-separated sow_id string
                        setEditedUser((prevUser) => ({
                          ...prevUser,
                          sowId: value, // Store the entire selected SoW objects
                          sows: sowidsString, // Updates clickedUser state with the comma-separated sow_id string
                        }));
                        console.log(
                          "Selected SoW IDs (comma-separated):",
                          sowidsString
                        ); // Debugging log
                      }}
                      fullWidth
                      sx={{
                        ".MuiAutocomplete-inputRoot": {
                          height: "40px", // Keeps input height fixed
                          overflow: "hidden", // Prevents content from overflowing
                        },
                      }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>

          <Grid item xs={3} className="image-upload-section">
            <Box className="image-preview">
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="Uploaded Preview"
                  className="preview-img"
                />
              ) : profileImageSrc ? (
                <img
                  src={profileImageSrc}
                  alt="Uploaded Preview"
                  className="preview-img"
                />
              ) : (
                <img
                  src="/profile-image.png"
                  alt="Profile Placeholder"
                  className="preview-img"
                />
              )}
            </Box>
            <Button
              variant="contained"
              component="label"
              className="upload-btn"
            >
              Upload Picture
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageUpload}
              />
            </Button>
          </Grid>
        </Grid>

        <EditPermissionsTable
          permissions={[...permissions]}
          setPermissions={setPermissions}
          appData={appData}
          handlePermissionChange={handlePermissionChange}
          handleDeletePermission={handleDeletePermission}
        />
        <Box className="modal-actions">
          <Grid className="left-button">
            <Button
              variant="contained"
              onClick={handleAddPermission}
              className="add-permission-btn"
              startIcon={<ControlPointIcon sx={{ color: "white" }} />}
            >
              Add Permission
            </Button>
            <Button
              variant="contained"
              className="clear-btn"
              onClick={handleClearClose}
              startIcon={<BackspaceIcon sx={{ color: "white" }} />}
            >
              Clear
            </Button>
          </Grid>
          <Button
            variant="contained"
            onClick={handleEditUser}
            className="submit-btn"
            startIcon={
              <PersonAddIcon style={{ color: "#fff" }}></PersonAddIcon>
            }
          >
            Save Changes
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditUserModal;
